import Vue from 'vue';
import Vuex from 'vuex';
import GeneralControl from '@/store/modules/GeneralControl';
import History from '@/store/modules/History';
import Ranking from '@/store/modules/Ranking';
import Deposit from '@/store/modules/Deposit';
import CashBack from '@/store/modules/Cashback';
import Result from '@/store/modules/Result';
import Item from '@/store/modules/Item';
import ExchangePoint from '@/store/modules/ExchangePoint';
import Lotto from '@/store/modules/Lotto';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    GeneralControl,
    History,
    Ranking,
    Deposit,
    CashBack,
    Result,
    Item,
    ExchangePoint,
    Lotto,
  },
});
